import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentChangeAction, Action, DocumentSnapshot } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(private afStore: AngularFirestore) { }

  async addEvent(event) {
    return await this.afStore.collection('events').add(event);
  }

  getEvents(id): Observable<DocumentChangeAction<{}>[]> {
    return this.afStore.collection('events', ref => ref.where('userId', '==', id)).snapshotChanges();
  }

  getEvent(id) {
    return this.afStore.collection('events').doc(id).valueChanges();
  }

}
